import { render, staticRenderFns } from "./MenuDataContainer.vue?vue&type=template&id=89dd5764"
import script from "./MenuDataContainer.vue?vue&type=script&lang=js"
export * from "./MenuDataContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports